// extracted by mini-css-extract-plugin
export default {"result":"result_result__DexWx","result__info":"result_result__info__VhL2y"};